import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9cd28c8c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "modal-container"
};
const _hoisted_2 = {
    key: 0,
    class: "wp-modal-body"
};
const _hoisted_3 = { class: "wp-modal-url-block" };
const _hoisted_4 = {
    key: 1,
    class: "wp-modal-body"
};
import { computed, ref } from "vue";
import WpBlock from "@/views/WebPageTests/WpBlock.vue";
import OneDeskRequestAccess from "@/components/organisms/OneDeskRequestAccess.vue";
import { requestAccessToRestrictedFeatures } from "@/repositories/claims.repository";
import useToastNotify from "@/shared/composables/toastNotifyHelper";
import { useStore } from "vuex";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WpModalTemplate',
    props: {
        isOpen: { type: Boolean },
        wpType: {},
        siteName: {},
        fullUrl: {},
        urlId: {},
        brand: {},
        market: {}
    },
    emits: ["update:is-open"],
    setup(__props, { emit: __emit }) {
        const { isOpen, wpType, siteName, fullUrl, urlId, brand, market } = __props;
        const emit = __emit;
        const store = useStore();
        const userId = computed(() => store.getters.getAccount.id);
        const notify = useToastNotify();
        const slug = (wp) => {
            switch (wp) {
                case "wp1":
                    return "load-testing";
                case "wp4":
                    return "page-performance";
                case "wp6":
                    return "accessibility";
                case "wp8":
                    return "seo";
                default:
                    return "";
            }
        };
        const requestView = ref(false);
        const requestAccessToWebsite = async (claimType, claimValue, reason) => {
            try {
                await requestAccessToRestrictedFeatures(userId.value, claimType, claimValue, reason);
            }
            catch (error) {
                notify("", error.message, "error");
            }
            closeModal();
        };
        const closeModal = () => {
            emit("update:is-open", false);
            const body = document.body;
            body.style.height = "";
            body.style.overflowY = "";
            requestView.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
                default: _withCtx(() => [
                    (_ctx.isOpen)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            (_ctx.isOpen && !requestView.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode(WpBlock, {
                                            wpType: _ctx.wpType,
                                            brand: _ctx.brand,
                                            market: _ctx.market,
                                            slug: slug(_ctx.wpType),
                                            "is-modal": true,
                                            "close-modal": closeModal,
                                            "site-name": _ctx.siteName,
                                            "full-url": _ctx.fullUrl,
                                            "url-id": _ctx.urlId,
                                            "request-view": requestView.value,
                                            onShowRequestView: _cache[0] || (_cache[0] = ($event) => (requestView.value = true))
                                        }, null, 8, ["wpType", "brand", "market", "slug", "site-name", "full-url", "url-id", "request-view"])
                                    ])
                                ]))
                                : (_ctx.isOpen && requestView.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(OneDeskRequestAccess, {
                                            "full-url": _ctx.fullUrl,
                                            "on-send-request": requestAccessToWebsite,
                                            "on-cancel-request": () => requestView.value = false,
                                            "site-name": _ctx.siteName,
                                            brand: _ctx.brand,
                                            market: _ctx.market
                                        }, null, 8, ["full-url", "on-cancel-request", "site-name", "brand", "market"])
                                    ]))
                                    : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
